import { lazy, Suspense } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";

const Goals = lazy(() =>
  import("@/components/Goals").then((m) => ({ default: m.Goals })),
);
const CoreValues = lazy(() =>
  import("@/components/CoreValues").then((m) => ({ default: m.CoreValues })),
);
const Services = lazy(() =>
  import("@/components/Services").then((m) => ({ default: m.Services })),
);
const OriginStory = lazy(() =>
  import("@/components/OriginStory").then((m) => ({ default: m.OriginStory })),
);
const Features = lazy(() =>
  import("@/components/Features").then((m) => ({ default: m.Features })),
);
const ReadyToGrow = lazy(() =>
  import("@/components/ReadyToGrow").then((m) => ({ default: m.ReadyToGrow })),
);
const Footer = lazy(() =>
  import("@/components/Footer").then((m) => ({ default: m.Footer })),
);

const Index = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "MarketingAgency",
        name: "The Outpost Creative",
        image:
          "https://vibe.filesafe.space/1776872650654765642/assets/4c5c9db5-afac-4612-9c16-5a06af1e56b3.png",
        url: "https://theoutpost.agency/",
        telephone: "+1-479-715-0378",
        email: "info@theoutpost.agency",
        description:
          "The Outpost Creative is a Bentonville, AR digital marketing agency helping service businesses turn unpredictable referrals into consistent leads with web design, SEO, and paid ads.",
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+1-479-715-0378",
          email: "info@theoutpost.agency",
          contactType: "customer support",
          areaServed: "US",
        },
        address: {
          "@type": "PostalAddress",
          addressLocality: "Bentonville",
          addressRegion: "AR",
          addressCountry: "US",
        },
        geo: {
          "@type": "GeoCoordinates",
          latitude: "36.3728",
          longitude: "-94.2088",
        },
        areaServed: [
          { "@type": "City", name: "Bentonville" },
          { "@type": "City", name: "Rogers" },
          { "@type": "City", name: "Fayetteville" },
          { "@type": "City", name: "Springdale" },
          { "@type": "City", name: "Bella Vista" },
          { "@type": "AdministrativeArea", name: "Northwest Arkansas" },
        ],
        priceRange: "$$",
        sameAs: ["https://www.instagram.com/theoutpostcreative/"],
        knowsAbout: [
          "Web Design",
          "Search Engine Optimization",
          "Google Business Profile Management",
          "Digital Marketing",
          "Website Design",
          "Local SEO",
          "Google Business Profile",
          "Paid Advertising",
          "Lead Generation",
        ],
        keywords:
          "website design, SEO, local SEO, Google Business Profile, paid advertising, lead generation, service businesses, Bentonville AR",
      },
      {
        "@type": "WebSite",
        url: "https://theoutpost.agency/",
        name: "The Outpost Creative",
      },
      {
        "@type": "WebApplication",
        name: "Free SEO Audit Tool",
        description:
          "Scan your website's SEO health, readability, content grade, and metadata in 30 seconds with The Outpost Creative's free SEO audit tool.",
        url: "https://theoutpost.agency/seo-audit",
        applicationCategory: "SEOApplication",
        operatingSystem: "Web",
        offers: {
          "@type": "Offer",
          price: "0",
          priceCurrency: "USD",
          description: "Free SEO audit with optional paid comprehensive audit.",
        },
        publisher: {
          "@type": "Organization",
          name: "The Outpost Creative",
          url: "https://theoutpost.agency/",
          email: "info@theoutpost.agency",
          telephone: "+1-479-715-0378",
          contactPoint: {
            "@type": "ContactPoint",
            telephone: "+1-479-715-0378",
            email: "info@theoutpost.agency",
            contactType: "customer support",
            areaServed: "US",
          },
          address: {
            "@type": "PostalAddress",
            addressLocality: "Bentonville",
            addressRegion: "AR",
            addressCountry: "US",
          },
        },
      },
    ],
  };

  return (
    <div className="min-h-screen bg-[#eee9e3] text-[#151515] selection:bg-[#b85736] selection:text-white">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <Suspense fallback={<div className="h-32" />}>
          <Goals className="relative pt-[45px] pb-[45px]" />
          <CoreValues className="relative pt-[45px] pb-0" />
          <Services hideServices={true} />
          <OriginStory className="relative pt-[45px] pb-[45px]" />
          <Features />
          <ReadyToGrow />
        </Suspense>
      </main>
      <Suspense fallback={<div className="h-32" />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
